<template>
  <header class="header">
    <nav class="nav container">
      <router-link to="/" class="logo" @click="closeMenu">
        <span class="logo-mark" aria-hidden="true">
          <img v-if="siteSettings.logo" :src="siteSettings.logo" alt="" class="logo-image" />
        </span>
        <span class="logo-text">{{ siteSettings.site_name }}</span>
      </router-link>

      <button
        class="nav-toggle"
        :class="{ open: isMenuOpen }"
        type="button"
        aria-controls="main-navigation"
        :aria-expanded="isMenuOpen"
        :aria-label="isMenuOpen ? 'Закрыть меню' : 'Открыть меню'"
        @click="toggleMenu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <button v-if="isMenuOpen" class="nav-backdrop" type="button" aria-label="Закрыть меню" @click="closeMenu"></button>

      <ul id="main-navigation" :class="['nav-menu', { open: isMenuOpen }]">
        <li><router-link to="/" :class="{ active: isActive('/') }" @click="closeMenu">Главная</router-link></li>
        <li><router-link to="/hsk" :class="{ active: isActive('/hsk') }" @click="closeMenu">Всё об HSK</router-link></li>
        <li><router-link to="/prices" :class="{ active: isActive('/prices') }" @click="closeMenu">Цены</router-link></li>
        <li><router-link to="/teachers" :class="{ active: isActive('/teachers') }" @click="closeMenu">Преподаватели</router-link></li>
        <li><router-link to="/reviews" :class="{ active: isActive('/reviews') }" @click="closeMenu">Отзывы</router-link></li>
        <li class="nav-menu-dropdown" 
            @mouseenter="handleMouseEnter"
            @mouseleave="handleMouseLeave">
          <button
             class="dropdown-trigger"
             type="button"
             :class="{ active: isCoursesActive() }"
             :aria-expanded="showCoursesDropdown"
             @click="toggleCoursesDropdown">
            Курсы
            <span class="dropdown-arrow" :class="{ open: showCoursesDropdown }">▼</span>
          </button>
          <ul class="dropdown-menu" :class="{ open: showCoursesDropdown }">
            <li>
              <router-link 
                to="/courses-hsk" 
                :class="{ active: isActive('/courses-hsk') }"
                @click="closeCoursesDropdown">
                Курсы HSK
              </router-link>
            </li>
            <li v-for="category in visibleCategories" :key="category.id">
              <router-link 
                :to="`/category/${category.slug}`" 
                :class="{ active: isActiveCategory(category.slug) }"
                @click="closeCoursesDropdown">
                {{ category.name }}
              </router-link>
            </li>
          </ul>
        </li>
        <li><router-link to="/contacts" :class="{ active: isActive('/contacts') }" @click="closeMenu">Контакты</router-link></li>
        <li class="nav-menu-cta">
          <a href="/school/" class="cta-button mobile-cta" @click="closeMenu">{{ isLoggedIn ? 'Личный кабинет' : 'Учиться' }}</a>
        </li>
      </ul>

      <a href="/school/" class="cta-button desktop-cta">{{ isLoggedIn ? 'Личный кабинет' : 'Учиться' }}</a>
    </nav>
  </header>
</template>

<script>
let cachedSiteSettings = null
let cachedCategories = null

export default {
  name: 'AppHeader',
  data() {
    return {
      siteSettings: cachedSiteSettings || {
        site_name: 'Мама я в Китае',
        logo: null
      },
      isMenuOpen: false,
      isLoggedIn: false,
      visibleCategories: cachedCategories || [],
      showCoursesDropdown: false
    }
  },
  async mounted() {
    await this.loadSiteSettings()
    await this.loadCategories()
    this.checkAuth()
    this.setupHeaderScrollEffect()
    this.$watch(() => this.$route.path, () => {
      this.isMenuOpen = false
      this.showCoursesDropdown = false
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    isActive(path) {
      return this.$route.path === path
    },
    isCoursesActive() {
      return this.$route.path.startsWith('/category/') || this.$route.path === '/courses-hsk'
    },
    isActiveCategory(slug) {
      return this.$route.path === `/category/${slug}`
    },
    async loadCategories() {
      if (cachedCategories) return
      try {
        const response = await fetch('/api/v1/public/product-categories');
        if (response.ok) {
          const data = await response.json();
          this.visibleCategories = data;
          cachedCategories = data;
        }
      } catch (error) {
        console.error('Error loading categories:', error);
      }
    },
    toggleCoursesDropdown() {
      this.showCoursesDropdown = !this.showCoursesDropdown
    },
    closeCoursesDropdown() {
      this.showCoursesDropdown = false
      this.closeMenu()
    },
    handleMouseEnter() {
      // На десктопе открываем при наведении
      if (window.innerWidth > 1024) {
        this.showCoursesDropdown = true
      }
    },
    handleMouseLeave() {
      // На десктопе закрываем при уходе мыши
      if (window.innerWidth > 1024) {
        this.showCoursesDropdown = false
      }
    },
    checkAuth() {
      const token = localStorage.getItem('studentAccessToken');
      this.isLoggedIn = !!token;
    },
    async loadSiteSettings() {
      if (cachedSiteSettings) return
      try {
        const response = await fetch('/api/v1/public/site-settings');
        if (response.ok) {
          const data = await response.json();
          this.siteSettings = data;
          cachedSiteSettings = data;
        }
      } catch (error) {
        console.error('Error loading site settings:', error);
      }
    },
    setupHeaderScrollEffect() {
      window.addEventListener('scroll', function() {
        const header = document.querySelector('.header');
        if (header) {
          if (window.scrollY > 100) {
            header.style.background = 'rgba(255, 255, 255, 0.98)';
            header.style.boxShadow = '0 2px 30px rgba(0,0,0,0.15)';
          } else {
            header.style.background = 'rgba(255, 255, 255, 0.95)';
            header.style.boxShadow = '0 2px 30px rgba(0,0,0,0.08)';
          }
        }
      });
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
      this.showCoursesDropdown = false
    },
    handleResize() {
      if (window.innerWidth > 1024) {
        this.isMenuOpen = false
      }
    },
  }
}
</script>

<style scoped>
.header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 30px rgba(0,0,0,0.08);
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 0;
}

.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 72px;
}

.nav-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border: 1px solid transparent;
  border-radius: 12px;
  background: #f7f8fa;
  cursor: pointer;
  padding: 0 11px;
  transition: background 0.2s ease, border-color 0.2s ease;
  position: relative;
  z-index: 1002;
}

.nav-toggle span {
  display: block;
  width: 20px;
  height: 2px;
  border-radius: 2px;
  background: #2c3e50;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.nav-toggle:hover,
.nav-toggle.open {
  background: #fff1ef;
  border-color: rgba(231, 76, 60, 0.2);
}

.nav-toggle:focus-visible {
  outline: 3px solid rgba(231, 76, 60, 0.25);
  outline-offset: 2px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: #2c3e50;
  font-weight: 700;
  font-size: 18px;
}

.logo-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.logo-mark {
  display: block;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
}

.logo-text {
  white-space: nowrap;
}

.nav-toggle.open span:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}

.nav-toggle.open span:nth-child(2) {
  opacity: 0;
}

.nav-toggle.open span:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}

.nav-backdrop {
  display: none;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 2rem;
  align-items: center;
  margin: 0;
  padding: 0;
}

.nav-menu a {
  color: #2c3e50;
  text-decoration: none;
  font-weight: 500;
  font-size: 15px;
  transition: color 0.3s ease;
  white-space: nowrap;
}

.nav-menu a:hover {
  color: #e74c3c;
}

.nav-menu a::after,
.nav-menu a:hover::after,
.nav-menu a.active::after {
  display: none;
}

.nav-menu-cta {
  display: none;
}

.cta-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  background: #e74c3c;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.cta-button:hover {
  background: #c0392b;
  transform: translateY(-1px);
}

.desktop-cta {
  display: inline-flex;
}

.mobile-cta {
  display: inline-flex;
  width: 100%;
  justify-content: center;
  margin-top: 8px;
}

@media (max-width: 1024px) {
  .nav-toggle {
    display: flex;
  }

  .desktop-cta {
    display: none;
  }

  .nav-menu {
    position: fixed;
    top: 72px;
    left: 12px;
    right: 12px;
    max-height: calc(100dvh - 88px);
    overflow-y: auto;
    background: rgba(255,255,255,0.98);
    backdrop-filter: blur(16px);
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 12px;
    gap: 2px;
    border: 1px solid rgba(44,62,80,0.08);
    border-radius: 16px;
    box-shadow: 0 24px 55px -20px rgba(15,23,42,0.35);
    transform: translateY(-12px) scale(0.98);
    transform-origin: top center;
    opacity: 0;
    pointer-events: none;
    transition: transform 0.22s ease, opacity 0.18s ease;
    z-index: 1001;
  }

  .nav-menu.open {
    transform: translateY(0) scale(1);
    opacity: 1;
    pointer-events: auto;
  }

  .nav-menu li {
    width: 100%;
    text-align: left;
  }

  .nav-menu > li > a:not(.mobile-cta) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 46px;
    padding: 11px 14px;
    border-radius: 10px;
    font-size: 16px;
  }

  .dropdown-trigger {
    justify-content: space-between;
    width: 100%;
    min-height: 46px;
    padding: 11px 18px 11px 14px;
    border-radius: 10px;
    font-size: 16px;
  }

  .nav-menu > li > a:hover,
  .nav-menu > li > a.active,
  .dropdown-trigger:hover,
  .dropdown-trigger.active {
    background: #fff4f2;
  }

  .nav-backdrop {
    display: block;
    position: fixed;
    inset: 72px 0 0;
    border: 0;
    background: rgba(15, 23, 42, 0.28);
    backdrop-filter: blur(2px);
    z-index: 1000;
  }

  .nav-menu-cta {
    display: block;
    width: 100%;
    margin-top: 8px;
  }

  .mobile-cta {
    width: 100%;
    min-height: 46px;
    margin-top: 4px;
  }
}

.nav-menu a.active {
  color: #e74c3c;
  position: relative;
}

.nav-menu a.active::after {
  display: none;
}

/* Выпадающее меню для курсов */
.nav-menu-dropdown {
  position: relative;
}

.nav-menu-dropdown > a,
.dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dropdown-trigger {
  padding: 0;
  border: 0;
  background: transparent;
  color: #2c3e50;
  font: inherit;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.3s ease;
}

.dropdown-trigger:hover,
.dropdown-trigger.active { color: #e74c3c; }

.dropdown-trigger:focus-visible {
  outline: 2px solid rgba(231, 76, 60, 0.35);
  outline-offset: 4px;
  border-radius: 4px;
}

.dropdown-arrow {
  font-size: 10px;
  margin-right: 3px;
  transition: transform 0.3s ease;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  list-style: none;
  padding: 8px 0;
  margin: 8px 0 0 0;
  min-width: 200px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;
  z-index: 1000;
}

.dropdown-menu.open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-menu li {
  margin: 0;
  width: 100%;
}

.dropdown-menu a {
  display: block;
  padding: 12px 20px;
  color: #2c3e50;
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease;
  text-align: left;
}

.dropdown-menu a:hover {
  background: #f8f9fa;
  color: #e74c3c;
}

.dropdown-menu a.active {
  background: #f8f9fa;
  color: #e74c3c;
  font-weight: 600;
}

@media (max-width: 1024px) {
  .nav-menu-dropdown {
    width: 100%;
  }

  .dropdown-trigger {
    justify-content: space-between;
    width: 100%;
    min-height: 46px;
    padding: 11px 24px 11px 14px;
    border-radius: 10px;
    font-size: 16px;
  }

  .dropdown-menu {
    position: static;
    box-shadow: none;
    background: transparent;
    padding: 0;
    margin: 2px 0 4px;
    transform: none;
    opacity: 1;
    visibility: visible;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }

  .dropdown-menu.open {
    max-height: 500px;
  }

  .dropdown-menu a {
    padding: 10px 14px 10px 30px;
    border-radius: 9px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .nav { height: 64px; }
  .logo { gap: 8px; font-size: 16px; min-width: 0; }
  .logo-mark { flex-basis: 36px; width: 36px; height: 36px; }
  .logo-text { overflow: hidden; text-overflow: ellipsis; }
  .nav-menu { top: 64px; left: 8px; right: 8px; max-height: calc(100dvh - 76px); }
  .nav-backdrop { inset: 64px 0 0; }
}
</style>
